import { REALTIME_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const PLATFORM_REALTIME_REPORT_ID = `platform${REALTIME_CAMPAIGN_SUFFIX}`;
